import { translate } from '@/data/fixture-transalations';
import CustomEquipoWithTooltip from '@/DesignSystem/components/partidos/CustomEquipoWithTooltip';
import { getCompetitionImage } from '@/helpers/leagues-helper';
import { Typography, Box, Link } from '@mui/material';
import CustomImageComponent from '@/components/shared/custom/custom-image';
import { getTeamImageById } from '@/helpers/images-helper';
import { convertUTCDateToLocalDateShort } from '@/helpers/datetime-helper';
import { Rutas } from '@/constants/rutas';

export const GoalBadge = ({ goals }) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            gap={0.5}
            border="1px solid"
            borderColor="border.main"
            width={25}
            height={25}
            justifyContent="center"
            borderRadius={1}
        >
            <Typography fontSize={16}>{goals}</Typography>
        </Box>
    );
};

const LastFixtureBanner = ({ data }) => {
    if (!data) return null;
    const { home, away, mode } = data;

    if (mode === 'predict' || mode === 'confirmed') {
        return null;
    }

    return (
        <>
            <Typography fontSize={14} fontWeight={500} mb={1}>
                Último partido
            </Typography>
            <Link href={`${Rutas.PARTIDO}/${data.id}/alineaciones-probables`} prefetch={false}>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    px={1}
                    py={0.5}
                    border="1px solid"
                    borderColor="border.light"
                    my={0.5}
                    width={'100%'}
                >
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <CustomImageComponent
                            src={getCompetitionImage(data.league, 18)}
                            alt="liga"
                            width={12}
                            height={12}
                        />
                        <Typography fontSize={14}>{translate(data.round, true)}</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" gap={0.5}>
                        <Box display="flex" alignItems="center" gap={0.5}>
                            <CustomEquipoWithTooltip
                                src={getTeamImageById(home.id, 36)}
                                alt={home.name}
                                width={22}
                                height={22}
                                label={home.name}
                                teamId={home.id}
                            />
                            <GoalBadge goals={home.goals} />
                        </Box>

                        <Box display="flex" alignItems="center" gap={0.5}>
                            <GoalBadge goals={away.goals} />
                            <CustomEquipoWithTooltip
                                src={getTeamImageById(away.id, 36)}
                                alt={away.name}
                                width={22}
                                height={22}
                                label={away.name}
                                teamId={away.id}
                            />
                        </Box>
                    </Box>

                    <Typography fontSize={12}>{convertUTCDateToLocalDateShort(data.date)}</Typography>
                </Box>
            </Link>
        </>
    );
};

export default LastFixtureBanner;
